// ANCHOR React
import { memo } from 'react';

// ANCHOR Base
import { Block } from 'baseui/block';
import { AspectRatioBox, AspectRatioBoxBody } from 'baseui/aspect-ratio-box';

// ANCHOR Components
import { LyonRestrictedImage } from './LyonRestrictedImage';

// ANCHOR Styles
import { BLOCK, CENTER } from './styles';

interface IProps {
  isCenter?: boolean;
}

export const LyonRestrictedImageContainer = memo(({ isCenter }: IProps) => (
  <Block overrides={isCenter ? CENTER : BLOCK}>
    <AspectRatioBox width="60%" aspectRatio={1}>
      <AspectRatioBoxBody>
        <LyonRestrictedImage />
      </AspectRatioBoxBody>
    </AspectRatioBox>
  </Block>
));
